import { FeatureRelease } from '@/components/feature-release/FeatureRelease'
import { CallWidgets } from './components/call-widgets'

export const SharedWidgets = () => {
    return (
        <>
            <FeatureRelease />
            <CallWidgets />
        </>
    )
}
